<div class="backdrop">
  <div class="information-container">
    <div id="avatar-container">
      <app-voip-conversation-avatar
        [conversation]="conversation"
        [size]="80"
      ></app-voip-conversation-avatar>
    </div>
    <div class="text-container">
      <div class="conversation-name">
        {{ conversationName }}
      </div>
      @if (!disableMessage) {
        <div>
          {{ message }}
        </div>
      }
    </div>
  </div>
</div>
@if (
  !disableBackground && ((isCapturingVideo$ | async) === false || isCallEnded)
) {
  <div class="solid-background"></div>
}
